/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icon';

/**
 * @deprecated since version 20.2.0. Please use the new Glyph component. You can read more about it in the prisma-design-system storybook under iconography/glyphs.
 */
const Information: any = ({ color, size = 'medium', ...props }) => {
  return (
    // @ts-expect-error TODO: Fix viewBox type in next ticket OF2-3365
    <Icon viewBox="13 6 2 22" size={size} color={color} {...props}>
      <g fillRule="evenodd">
        <path d="M3 16.993C3 10.913 7.911 6 14.012 6 20.112 6 25 10.916 25 16.993 25 23.06 20.115 28 14.012 28S3 23.06 3 16.993zm1.324 0c0 5.343 4.328 9.664 9.69 9.664 5.3 0 9.69-4.32 9.69-9.664 0-5.316-4.39-9.7-9.69-9.7-5.365-.002-9.69 4.384-9.69 9.7zm7.902 6.323v-.892h.907v-7.4h-.907v-.865h2.643v8.265h.92v.892h-3.564zm.467-11.369c0-.723.557-1.32 1.27-1.32.739 0 1.35.597 1.35 1.32 0 .777-.611 1.306-1.35 1.306-.726 0-1.27-.53-1.27-1.306z" />
      </g>
    </Icon>
  );
};

export default Information;

Information.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
